import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddShipmentsDetailsComponent } from 'src/app/core/dialogs/add-shipments-details/add-shipments-details.component';
import { DeletePalletDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { ShipmentsService } from 'src/app/service/document-control/shipments.service';
import { ExportStateService } from 'src/app/service/export-state.service';
import { TooltipFieldComponent } from 'src/app/core/dialogs/tooltip-field/tooltip-field.component'
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-shipments-details',
    templateUrl: './shipments-details.component.html',
    styleUrls: ['./shipments-details.component.scss'],
    standalone: false
})
export class ShipmentsDetailsComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  userId: any;
  shipmentId;
  isAccessible = false;
  freightTypeDropDown: any;
  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]
  constructor(private readonly router: Router, private readonly dialog: MatDialog, private readonly shipmentsService: ShipmentsService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly location: Location, private readonly exportStateService: ExportStateService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles();
    this.columnDefs = [
      {
        headerName: "INVOICE", field: "invoiceNumber", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, autoHeight: true, width: 140,
      },
      {
        headerName: "DESCRIPTION", field: "freightType", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, autoHeight: true, width: 175,
      },
      {
        headerName: "SETS", field: "invoiceSets",
        autoHeight: true, width: 100, cellStyle: this.cellStyling1,
        cellRenderer: TooltipFieldComponent,
        cellRendererParams: (params: ICellRendererParams) =>
          this.formatToolTip(params.data),
      },
      {
        headerName: "PALLETS", field: "invoicePallets",
        autoHeight: true, width: 100,
      },
      {
        headerName: "NET WEIGHT", field: "invoiceNetWeight",
        autoHeight: true, width: 170,
      },
      {
        headerName: "GROSS WEIGHT", field: "invoiceGrossWeight",
        autoHeight: true, width: 170, cellStyle: this.cellStyling,
        cellRenderer: TooltipFieldComponent,
        cellRendererParams: (params: ICellRendererParams) =>
          this.formatToolTip1(params.data),
      },
      {
        headerName: "VALUE", field: "partValue",
        autoHeight: true, width: 125,
      },
      {
        headerName: "IT BOND", field: "it",
        autoHeight: true, width: 125,
      },

      {
        headerName: "BA#", field: "value",
        autoHeight: true, width: 125,
      },
      {
        headerName: "ASN COMMENTS", field: "asnComment",
        autoHeight: true, width: 250,
      },

      {
        headerName: "ACTIONS", field: "shipmentdetails_editdelete", width: 150, cellRenderer: BtnCellRendererEditDelete
      },

    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    const userData = sessionStorage?.getItem('FGA');
    if (userData)
    {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }
    this.shipmentId = JSON.parse(localStorage.getItem('shipment-details'));
    this.shipmentsDropDownData()
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }



  cellStyling(params) {
    if (Number(params.data.weightVariance) != 0) { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    }
    return {}
  }

  cellStyling1(params) {
    if (Number(params.data.quantityVariance) != 0) { // NOSONAR
      return { 'background-color': 'red', 'color': 'black' };
    }
    return {}
  }

  formatToolTip(params: any) {
    const first = params.asnSets
    const middle = params.invoiceSets
    const last = params.quantityVariance
    const lineBreak = true;
    const toolTipArray = ["ASN:" + first, 'Invoice:' + middle, 'Variance:' + last];
    return { toolTipArray, lineBreak };
  }

  formatToolTip1(params: any) {
    const first = params.asnWeight
    const middle = params.invoiceGrossWeight
    const last = params.weightVariance
    const lineBreak = true;
    const toolTipArray = ["ASN:" + first, 'Invoice:' + middle, 'Variance:' + last];
    return { toolTipArray, lineBreak };
  }

  async shipmentsDropDownData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    await this.shipmentsService.loadFreightTypeDropDown().then(x => {

      if (x && x.length > 0) {
        this.freightTypeDropDown = [];
        x.forEach(element => {
          this.freightTypeDropDown.push({ description: element.description, freightTypeId: element.freightTypeId })
        });
      }
    })

    this.refreshData()
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  refreshData() {
  if (this.shipmentId) {

    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.shipmentsService.loadShipmentDetailsData(this.shipmentId).subscribe(

      response => {

        this.displayRowData = (response || []).filter(row => {

  const hasTextData =
    !!row.invoiceNumber ||
    !!row.freightType ||
    !!row.it ||
    !!row.asnComment;

  const hasNumericData =
    Number(row.invoiceSets || 0) > 0 ||
    Number(row.invoicePallets || 0) > 0 ||
    Number(row.invoiceNetWeight || 0) > 0 ||
    Number(row.invoiceGrossWeight || 0) > 0 ||
    Number(row.partValue || 0) > 0;

  return hasTextData || hasNumericData;
});

        this.gridApi?.setGridOption('rowData', this.displayRowData);

        if (this.displayRowData.length === 0) {
          this.gridApi?.showNoRowsOverlay();
        } else {
          this.gridApi?.hideOverlay();
        }

        this.rowCount = this.displayRowData.length;

        if (this.displayRowData.length) {

          this.totalRecords = this.displayRowData.length;

          this.paginationPageSize =
            this.rpPage !== 'ALL'
              ? this.paginationPageSize
              : this.totalRecords;

          this.tPage =
            this.rpPage !== 'ALL'
              ? Math.ceil(this.totalRecords / this.rpPage)
              : 1;

          this.sRecord = 1

          this.eRecord =
            this.rpPage > this.totalRecords
              ? this.totalRecords
              : this.rpPage

          if (this.cPage > this.tPage) {
            this.cPage = 1;
          }
        }

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },

      _error => {

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

        this.errorMessage = this.constants.APIErrorMessage;

        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);

      }
    );

  }
  else {

    setTimeout(() => {
      this.successMessage = "";
      this.errorMessage = "";
    }, this.constants.notificationMessageTimeShort);

  }
}

  addShipmentsDetails() {
    const dialogRef = this.dialog.open(
      AddShipmentsDetailsComponent, {
      disableClose: true,
      width: '820px',
      data: {
        header: 'ADD SHIPMENT INVOICE',
        eventType: 'ADD',
        userId: this.userId,
        shipmentId: this.shipmentId,
        freightTypeDropDown: this.freightTypeDropDown
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = this.constants.APIDataSaved;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }

  deleteTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      DeletePalletDialogComponent, {
      disableClose: true,
      width: 'max-content',
      data: {
        header: 'Are you sure you want to delete this Shipment Invoice?',
        description: "Invoice : " + data.invoiceNumber
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == "ConfirmEvent") { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.shipmentsService.deleteInvoices(data.invoiceId).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.refreshData();
            }

          }, _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          })
      }
    }
    );
  }
  editTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      AddShipmentsDetailsComponent, {
      disableClose: true,
      width: '820px',
      data: {
        header: 'EDIT SHIPMENT INVOICE',
        eventType: 'EDIT',
        userId: this.userId,
        invoiceId: data.invoiceId,
        invoiceNumber: data.invoiceNumber,
        shipmentId: data.shipmentId,
        p_sets: data.invoiceSets,
        p_pallets: data.invoicePallets,
        netWeight: data.invoiceNetWeight,
        grossWeight: data.invoiceGrossWeight,
        partValue: data.partValue,
        ba214: data.value,
        it: data.it,
        comments: data.asnComment,
        freightTypeId: data.freightTypeId,
        freightTypeDropDown: this.freightTypeDropDown

      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataUpdated;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();
      }
    });
  }


  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }
  goBack() {
    this.location.back();
  }
}
